<!-- Copyright (c) 2023 Proto Labs, Inc. All Rights Reserved. -->

<template>
  <div class="welcome-header">
    <h1>{{ $t("signIn.welcomeBack") }}</h1>
  </div>
</template>

<script lang="ts">
export default {
  name: 'welcome-header',
};
</script>

<style lang="scss" scoped>
h1 {
  @include font-header-medium-h1;
  color: $primary-gray;
  margin-bottom: 30px;
}

p {
  @include font-body-book-regular;
  margin-bottom: 30px;
  color: $primary-gray;
}
</style>
